export default {
    cancelText: '取消',
};
